import { useRef } from 'react';
import axios from 'axios';

export type EngagementType = 'click' | 'hover' | 'reaction' | 'question';

interface Coordinates {
  x: number;
  y: number;
}

interface ReactionPayload {
  field: string;
  emoji: string;
  coordinates?: Coordinates;
}

interface QuestionPayload {
  field: string;
  question: string;
  coordinates?: Coordinates;
}

export interface ClickPayload {
  type:
    | 'field_click'
    | 'link_click'
    | 'accordion_click'
    | 'overview_click'
    | 'field_click'
    | 'link_click'
    | 'reference_click'
    | 'language_click'
    | 'prompt_click'
    | 'idea_work_click';
  field: string;
  url?: string;
  coordinates?: Coordinates;
}

interface HoverPayload {
  field: string;
  coordinates?: Coordinates;
}

const useEngagement = (section: string) => {
  const hoverStartRef = useRef<number | null>(null);

  const getScreenType = (): string => {
    const width = window.innerWidth;
    if (width < 576) return 'xs';
    if (width < 768) return 'sm';
    if (width < 992) return 'md';
    if (width < 1200) return 'lg';
    return 'xl';
  };

  const sendEngagement = async (type: EngagementType, value?: string | object) => {
    try {
      const screenType = getScreenType();
      let data: any;
      if (value && typeof value === 'object') {
        data = {
          section,
          type,
          timestamp: new Date().toISOString(),
          pageUrl: window.location.href,
          ...value,
          screenType,
        };
      } else {
        data = {
          section,
          type,
          timestamp: new Date().toISOString(),
          pageUrl: window.location.href,
          value,
        };
      }
      console.log(`Sending engagement [${type}] for [${section}]:`, data);
      await axios.post('/api/engagement', data);
    } catch (error) {
      console.error(`Engagement [${type}] failed for [${section}]`, error);
    }
  };

  const onClick = (payload: ClickPayload) => {
    console.log(payload);
    sendEngagement('click', payload);
  };

  const onHoverStart = (payload: HoverPayload) => {
    hoverStartRef.current = Date.now();
  };

  const onHoverEnd = (payload: HoverPayload) => {
    if (hoverStartRef.current !== null) {
      const duration = Date.now() - hoverStartRef.current;
      sendEngagement('hover', { ...payload, duration });
      hoverStartRef.current = null;
    }
  };
  const onReaction = (payload: ReactionPayload) => sendEngagement('reaction', payload);

  const onQuestion = (payload: QuestionPayload) => sendEngagement('question', payload);

  return {
    onClick,
    onHoverStart,
    onHoverEnd,
    onReaction,
    onQuestion,
    sendEngagement,
  };
};

export default useEngagement;
